import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { CountryData } from '../../_models/country';
import { CurrencyData } from '../../_models/currency';
import { Counts } from '../../_models/data';
import { ApiService } from '../../_services/api.service';
import { ChecksService } from '../../_services/checks.service';
import { NotificationService } from '../../_services/notification.service';

@Component({
  selector: 'app-countries',
  templateUrl: './countries.component.html',
  styleUrl: './countries.component.css'
})
export class CountriesComponent implements OnInit {
  routeParams: Params;
  queryParams: Params;
  
  // userData: UserData;
  page: number = 1;
  count: Counts;

  url = this.router.url.slice(1);

  mainHeader: string = "List All Countries";
  formHeader: string = "Add New Country";
  view: string = "";

  processing: boolean = false;
  loading: boolean = true;
  buttonText: string = "Add New Country";

  countryList: CountryData[] = [];
  currencyList: CurrencyData[] = [];

  edit: boolean = false;
  countryName: string = '';
  countryRef: number = 0;
  selectedCurrencyRefs: number[] = [];
  selectedCountryForCurrencies: CountryData = null;

  dataForm = this.fb.group({
    ref: [0],
    title: ["", Validators.required],
    iso: ["", Validators.required],
    online: [true, Validators.required],
  }, {});

  get ref() { return this.dataForm.get('ref'); }
  get title() { return this.dataForm.get('title'); }
  get iso() { return this.dataForm.get('iso'); }
  get online() { return this.dataForm.get('online'); }

  constructor(
    private fb: FormBuilder,
    public checkService: ChecksService,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private notifyService: NotificationService,
    private router: Router,
  ) {
    this.checkService.checkSession();
    this.getRouteParams();
  }

  ngOnInit(): void {

    if (this.routeParams['view'] !== undefined) {
      this.view = this.routeParams['view'];
      this.mainHeader = "List "+this.view+" Countries";
    }

    if (this.queryParams['page'] !== undefined) {
      this.page = this.queryParams['page'];
    } else {
      this.page = 1;
    }
    this.getCountries(this.page);
    this.getActiveCurrencies();
  }

  getActiveCurrencies() {
    this.apiService.getAssignableCurrencies().subscribe(data => {
      this.checkService.checkLoggedin(data);
      if (data.success == true) {
        this.currencyList = data.data || [];
      }
    });
  }

  getCountries(page:number) {
    this.loading = true;

    this.apiService.getCountries(page, this.view).subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        this.loading = false
        if (data.success == true) {
          this.count = data.counts;
          this.countryList = data.data;
        } else {
          this.notifyService.showError(data.error.message, "Error")
        }
      }
    );

  }

  onCreate() {
    var data: object = {
      title: this.dataForm.value.title,
      iso: this.dataForm.value.iso,
      online: this.dataForm.value.online,
    };
    if (this.edit === true) {
      data['ref'] = this.dataForm.value.ref;
      this.editCountry(data);
    } else {
      data['online'] = 0;
      this.createCountry(data);
    }
  }

  createCountry( data ) {
    this.processing = true;

    this.buttonText = "Adding New Country...";
    this.apiService.createCountry(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Created "+data.title+" as a country", "Country Created");
          this.checkService.closeModal('modal-country-form');
          this.ngOnInit();
          this.dataForm.reset();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }
        this.buttonText = "Add New Country";
      }
    );
  }

  editCountry( data ) {
    this.processing = true;

    this.buttonText = "Saving Changes...";
    this.apiService.editCountry(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("saved changes made to country", "Country Edited");
          this.checkService.closeModal('modal-country-form');
          this.ngOnInit();
          this.dataForm.reset();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }
        this.buttonText = "Add New Country";
        this.edit = false;
      }
    );
  }

  getEdit(data:CountryData) {
    this.dataForm.patchValue({
      ref: data.ref,
      title: data.title,
      iso: data.iso,
      online: data.online,
    });
    this.edit = true;
    this.formHeader = "Edit "+data.title;
    this.buttonText = "Edit Country";
  }

  onCancel() {
    this.edit = false;
    this.dataForm.reset({
      ref: 0,
      title: "",
      iso: "",
      online: true,
    });
    this.formHeader = this.buttonText = "Add New Country";
  }

  openCurrencyManager(country: CountryData) {
    this.selectedCountryForCurrencies = country;
    this.selectedCurrencyRefs = (country.currencies || [])
      .map(currency => Number(currency.currencyRef || currency.ref))
      .filter(ref => ref > 0);
  }

  toggleCurrency(currency: CurrencyData, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    const ref = Number(currency.currencyRef || currency.ref);
    if (checked && !this.selectedCurrencyRefs.includes(ref)) {
      this.selectedCurrencyRefs.push(ref);
    } else if (!checked) {
      this.selectedCurrencyRefs = this.selectedCurrencyRefs.filter(item => item !== ref);
    }
  }

  isCurrencySelected(currency: CurrencyData) {
    const ref = Number(currency.currencyRef || currency.ref);
    return this.selectedCurrencyRefs.includes(ref);
  }

  saveCountryCurrencies() {
    if (!this.selectedCountryForCurrencies) {
      return;
    }
    this.processing = true;
    this.apiService.assignCountryCurrencies({
      country: this.selectedCountryForCurrencies.ref,
      currencies: this.selectedCurrencyRefs,
    }).subscribe(data => {
      this.checkService.checkLoggedin(data);
      this.processing = false;
      if (data.success == true) {
        this.notifyService.showSuccess("Currencies updated", "Country Modified");
        this.checkService.closeModal('modal-country-currencies');
        this.getCountries(this.page);
      } else {
        this.notifyService.showError(data.error.message + ". " + data.error.additional_message, "Error");
      }
    });
  }

  getRouteParams() {
    // Route parameters
    this.activatedRoute.params.subscribe( params => {
        this.routeParams = params;
    });

    // URL query parameters
    this.activatedRoute.queryParams.subscribe( params => {
        this.queryParams = params;
    });

    // URL get change
    this.activatedRoute.url.subscribe(url =>{
      this.ngOnInit();
    });
  }

  changeCountryStatus(action:string, ref:number) {
    let data:Object = {
      ref: ref,
      status: action.toLowerCase()
    }

    this.processing = true;

    this.apiService.changeCountryStatus(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Changes made to Country successfully", "Country Modified");
          this.ngOnInit();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }

        document.getElementById('modal-activate').click();
        document.getElementById('modal-deactivate').click();
        document.getElementById('modal-online').click();
        document.getElementById('modal-offline').click();
        document.getElementById('modal-delete').click();
      }
    );
  }

  changeCountryVisibility(action:string, ref:number) {
    let data:Object = {
      ref: ref,
      status: action.toLowerCase()
    }

    this.processing = true;

    this.apiService.changeCountryVisibility(data).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Changes made to Country successfully", "Country Modified");
          this.ngOnInit();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }

        document.getElementById('modal-activate').click();
        document.getElementById('modal-deactivate').click();
        document.getElementById('modal-online').click();
        document.getElementById('modal-offline').click();
        document.getElementById('modal-delete').click();
      }
    );
  }

  deleteCountry(ref:number) {
    this.processing = true;

    this.apiService.deleteCountry(ref).subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Country Removed Successfully", "Country Deleted");
          this.ngOnInit();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }

        document.getElementById('modal-activate').click();
        document.getElementById('modal-deactivate').click();
        document.getElementById('modal-online').click();
        document.getElementById('modal-offline').click();
        document.getElementById('modal-delete').click();
      }
    );
  }

  getDataFromList(name:string, ref:number) {
    this.countryName = name;
    this.countryRef = ref;
  }
}
